// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/_css-loader@1.0.1@css-loader/index.js?minimize!../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!../../../node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js!../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=styles&index=1!./detectionSummary.vue");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/_vue-style-loader@4.1.3@vue-style-loader/lib/addStylesClient.js").default
var update = add("47125c91", content, true, {});